export const defaultHiddenFilterName = 'default name for a hidden filter';
